import { GenericSavedReport } from '../types-store';
import { SavedReportEvaluationWire } from '../types';

export const mergeSavedReportsWithEvaluations = <SavedReport extends GenericSavedReport>(
  savedReports: SavedReport[],
  evaluationsWire: SavedReportEvaluationWire[]
): SavedReport[] => {
  return savedReports
    ?.map(savedReport => ({
      ...savedReport,

      code: {
        value: savedReport.code?.value,
        description: savedReport.code?.description
      },

      selectedReport: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.value)
        ?.report,

      editable: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.value)
        ?.editable ?? false
    }));
};
